import React from 'react'
import { Typography } from "antd";

const EmiDisplayCard = ({ data, divider, onCardClick }) => {
    const { logoUrl, name, emiMethod, emiOfferTypes, } = data;

    const getEmiOfferText = (offerTypes) => {
        const hasNoCostEmi = offerTypes.includes("NoCostEmi");
        const hasLowCostEmi = offerTypes.includes("LowCostEmi");

        if (hasNoCostEmi && hasLowCostEmi) {
            return "No and Low-Cost EMI available";
        } else if (hasNoCostEmi) {
            return "No-Cost EMI available";
        } else if (hasLowCostEmi) {
            return "Low-Cost EMI available";
        }
        return null;
    };

    return (
        <div>
            <div className='emiDisplayCardContainer' onClick={() => onCardClick(data)} style={{ borderBottom: divider ? "1px dashed #eee" : null }}>
                <div className='emiDisplayCardBox'>
                    <div className='bankNameBox'>
                        <img src={logoUrl} alt="" className="emi-bank-logo" width={35} />
                        <Typography className="emiOptionHeading dynamic-font-family"> {name} </Typography>
                    </div>
                    <div className='interestBox'>
                        <Typography className="emiOptionHeading dynamic-font-family"> {`${emiMethod?.effectiveInterestRate}% p.a`}</Typography>
                        <img src="/assets/others/right-arrow.svg" alt="right-arrow" width={10} />
                        {/* <RightOutlined className="forwardIcon dynamic-font-family" /> */}
                    </div>
                </div>
                {emiOfferTypes?.length > 0 && (
                    <div className="offerTextShow">
                        <div className="no-cost-emi-available">
                            <Typography className="no-cost-text">
                                {getEmiOfferText(emiOfferTypes)}
                            </Typography>
                        </div>
                    </div>
                )}
            </div>
            {/* {divider && <Divider />} */}
        </div>
    )
}

export default EmiDisplayCard